import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { refSagaActions } from "../../Administration/ReferenceInfoManagement";

import { Form, Modal, Button, Col, Spinner, InputGroup } from "react-bootstrap";
import { Formik } from "formik";
import { X, CaretRight } from "react-bootstrap-icons";
import * as Yup from "yup";
import { format, parseISO } from "date-fns";
import styles from "../css/receiptManagement.module.css";

const moneyFormater = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "PGK"
});

const formSchema = Yup.object().shape({
  prioritySearch: Yup.object({}),
  otpCode: Yup.string()
    .matches(/^[a-zA-Z0-9]{5}$/, "*Enter 5 alphanumeric characters")
    .required("*Please enter the OTP code")
});

export const ReceiptVerifyModal = ({ show, receiptInfo, status, cancel, onCloseModal, handleOTPSubmit, otpVerified, verifyingOTP, handleOTPResend, otpVerifiedRes }) => {

  const dispatch = useDispatch();

  const { reference, auth } = useSelector(state => state);

  const { allReferences, referenceKinds } = reference;
  const { user } = auth;

  const [ rptIssuedId, setRptIssuedId ] = useState();
  const [ rptUsedId, setRptUsedId ] = useState();
  const [ rptRIPId, setRptRIPId ] = useState();
  const [ rptRCId, setRptRCId ] = useState();
  const [ rptInvalidId, setRptInvalidId ] = useState();
  const [ enableResend, setEnableResend ] = useState(true);
  const [ showInvalidOTP, setShowInvalidOTP ] = useState(false);
  const [ otpSent, setOTPSent ] = useState(false);
  const [ verificationMsg, setVerificationMsg ] = useState("");

  const [ statColor, setStatColor ] = useState("text-primary");

  const [ rptDate, setRptDate ] = useState("");
  const [ rptTime, setRptTime ] = useState("");


  const initalVal = { otpCode: "" };
  const provAgencyId = user.prov_agency_id;

  useEffect(() => {
    setTimeout(() => {
      setEnableResend(false);
    }, 30000);
  });

  useEffect(() => {
    if(Object.keys(otpVerifiedRes).length > 0){
      if(otpVerifiedRes.result.data){
        setVerificationMsg(otpVerifiedRes.result.data);
      } else {
        setVerificationMsg("Invalid OTP entered");
      }
      
    }
  }, [otpVerifiedRes]);

  useEffect(() => {
    if(receiptInfo && Object.keys(receiptInfo).length > 1){
      
      setRptDate(format(parseISO(receiptInfo.audit_datetime), "dd-MMM-yyyy"));
      setRptTime(format(parseISO(receiptInfo.audit_datetime), "HH:mm a"));
    }
  }, [receiptInfo, rptDate, rptTime]);

  useEffect(() => {
    dispatch(refSagaActions.fetchAllReferences());
    dispatch(refSagaActions.fetchReferenceKinds());
  }, [dispatch]);

  useEffect(() => {
    if(referenceKinds.length > 1){
      let receiptStatusKind = referenceKinds.find((kind) => (kind.code === "RECEIPT_STATUS"));
      let recStats = allReferences.filter((ref) => (ref.kindId === receiptStatusKind.id));
      recStats.forEach((stat) => {
        if (stat.code === "ISSUED"){
          setRptIssuedId(stat.id);
        } else if (stat.code === "USED"){
          setRptUsedId(stat.id);
        } else if (stat.code === "RIPROG"){
          setRptRIPId(stat.id);
        } else if (stat.code === "RCOMP"){
          setRptRCId(stat.id);
        } else if (stat.code === "INVALID"){
          setRptInvalidId(stat.id);
        }
      })
    }
  }, [referenceKinds, allReferences]);

  useEffect(() => {

    if(Number(receiptInfo.rcpt_status_id) === rptIssuedId){
      setStatColor("text-primary");
    } else if(Number(receiptInfo.rcpt_status_id) === rptUsedId || Number(receiptInfo.rcpt_status_id) === rptInvalidId){
      setStatColor("text-danger");
    } else if(Number(receiptInfo.rcpt_status_id) === rptRIPId){
      setStatColor("text-warning");
    } else if(Number(receiptInfo.rcpt_status_id) === rptRCId){
      setStatColor("text-muted");
    }

  }, [rptIssuedId, rptUsedId, rptRIPId, rptRCId, rptInvalidId, receiptInfo]);

  useEffect(() => {
    if (otpVerified && !verifyingOTP){
      setShowInvalidOTP(false);
      onCloseModal();
      setOTPSent(false);
    } else if (!otpVerified && !verifyingOTP && otpSent) {
      setShowInvalidOTP(true);
      setOTPSent(false);
    }
  }, [ otpVerified, verifyingOTP, onCloseModal, otpSent, otpVerifiedRes, verificationMsg ]);

  const handleSubmitOtp = (query) => {
    let otpQuery = {
      receipt_number: receiptInfo.rcpt_number,
      pin: query.otpCode
    };
    handleOTPSubmit(otpQuery);
  };

  const resendOTP = () => {
    setEnableResend(true);
    handleOTPResend();
  };

  const onCancel = () => {
    setShowInvalidOTP(false);
    setOTPSent(false);
    cancel();
  };


  return (
    <Modal show={show} size="lg" aria-labelledby="contained-modal-title-vcenter" centered >

      <Modal.Header style={{display: "inline"}} closeButton>

        <Modal.Title>
          <div className="row">
            <div className="col-6">
              Receipt No: <b>{receiptInfo.rcpt_number}</b>
            </div>
            <div className="col-6">
              Receipt Status: <span className={statColor}>{receiptInfo.rcpt_status_desc}</span>
            </div>
          </div>
        </Modal.Title>

      </Modal.Header>

      <Modal.Body>

        <div className={styles.modalRcptInfo}>
          <div className="row">
            <div className="col-3">
              <b>Customer Name:</b>
            </div>
            <div className="col-9">
              {receiptInfo.cust_first_name + " " + receiptInfo.cust_last_name}
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <b>Mobile No. :</b>
            </div>
            <div className="col-9">
              {receiptInfo.cust_msisdn}
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <b>Department:</b>
            </div>
            <div className="col-9">
              {receiptInfo.dept_name}
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <b>Service Type:</b>
            </div>
            <div className="col-9">
              {receiptInfo.service_name}
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <b>Service Item:</b>
            </div>
            <div className="col-9">
              {receiptInfo.service_item_desc}
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <b>Amount:</b> 
            </div>
            <div className="col-9">
              {moneyFormater.format(receiptInfo.total_amnt)}
            </div>
          </div>

        </div>
        <hr/>
        { Number(receiptInfo.pa_id) !== provAgencyId ?
        <div>
            <p>
              This service is to be rendered at the <b>{receiptInfo.dept_name}</b> in the 
              <b>
                { 
                  receiptInfo.province_name === "Northern (Oro Province)" ||
                  receiptInfo.province_name === "Bougainville (North Solomons)" ||
                  receiptInfo.province_name === "Western Province (Fly River)" ||
                  receiptInfo.province_name === "National Capital District"
                  ? receiptInfo.province_name : " " + receiptInfo.province_name + " Province"
                } 
              </b>.
            </p>
        </div>
        :
        <div>
        <div className={styles.modalRcptInfo}>
          <div className="row" style={{ display: "flex", alignItems: "center"}}>

            { Number(receiptInfo.rcpt_status_id) === rptUsedId &&
              <p>
                Receipt No. <b>{receiptInfo.rcpt_number}</b> has already been <span className={statColor}> <b>USED</b> </span> on the <b>{rptDate}</b> at <b>{rptTime}</b> to render service,
                <b> {receiptInfo.service_item_number}: {receiptInfo.service_item_desc}</b> to <b>{receiptInfo.cust_first_name + " " + receiptInfo.cust_last_name}</b>.
              </p>
            }

            { Number(receiptInfo.rcpt_status_id) === rptRIPId &&
              <p>
                Receipt No. <b>{receiptInfo.rcpt_number}</b> is currently being <span className={statColor}> <b> processed for a refund</b> </span>, submitted on the <br/> 
                <b>{rptDate}</b> at <b>{rptTime}</b> for service, <b> {receiptInfo.service_item_number}: {receiptInfo.service_item_desc}</b> for <b>{receiptInfo.cust_first_name + " " + receiptInfo.cust_last_name}</b>.
              </p>
            }

            { Number(receiptInfo.rcpt_status_id) === rptRCId &&
              <p>
                Receipt No. <b>{receiptInfo.rcpt_number}</b> was <span className={statColor}> <b>REFUNDED</b> </span> on the <b>{rptDate}</b> at <b>{rptTime}</b> for service, <br/>
                <b> {receiptInfo.service_item_number}: {receiptInfo.service_item_desc}</b> to <b>{receiptInfo.cust_first_name + " " + receiptInfo.cust_last_name}</b>.
              </p>
            }

            { Number(receiptInfo.rcpt_status_id) === rptInvalidId &&
              <p>
                Receipt No. <b>{receiptInfo.rcpt_number}</b> is <span className={statColor}> <b>INVALID</b> </span>.
              </p>
            }
          </div>
            { Number(receiptInfo.rcpt_status_id) === rptIssuedId && (
              <>
                <p>
                  Receipt No. <b>{receiptInfo.rcpt_number}</b> was <span className={statColor}> <b>ISSUED</b> </span> on the <b>{rptDate}</b> at <b>{rptTime}</b> for service, <br/>
                  <b> {receiptInfo.service_item_number}: {receiptInfo.service_item_desc}</b> to be rendered to <b>{receiptInfo.cust_first_name + " " + receiptInfo.cust_last_name}</b>.
                </p>
                <div className="row">
                  <div className="col-8">
                    <b>Enter OTP code sent to <b> (+675) {receiptInfo.cust_msisdn.slice(3, 11)} </b> for verification.</b>
                  </div>
                  <div className="col-4" style={{ display: "flex", justifyContent: "end"}}>
                    <Button variant="outline-info" onClick={resendOTP} disabled={enableResend} > Resend OTP </Button>
                  </div>
                </div>
              </>
            )} 
        </div>
        { Number(receiptInfo.rcpt_status_id) === rptIssuedId && (
            <div className={styles.modalRcptInfo}>
              <Formik
                initialValues={initalVal}
                validationSchema={formSchema}
                onSubmit={(values, {setSubmitting}) => {
                  setSubmitting(true);
                  setOTPSent(true);
                  handleSubmitOtp(values);
                  setSubmitting(false);
                }}
              >
                {( { values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting }) => (
                  <Form>
                    <Form.Row>
                      <Col>
                        <Form.Label> Enter the OTP code received from customer mobile </Form.Label>
                        <InputGroup>
                          <Form.Control
                            name="otpCode"
                            value={values.otpCode}
                            placeholder="Enter OTP code"
                            onChange={(e) => { setShowInvalidOTP(false); handleChange(e);}}
                            onBlur={handleBlur}
                            style={touched.otpCode && errors.otpCode && { border: "1px solid red" } }
                          />
                          <InputGroup.Append>
                            <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting} style={{ display: "flex", alignItems: "center"}}>
                              Submit &nbsp;
                              { verifyingOTP ? <Spinner animation="border" size="sm" /> : <CaretRight /> }
                            </Button>
                          </InputGroup.Append>
                        </InputGroup>
                      </Col>
                    </Form.Row>
                    <Form.Row>
                      {touched.otpCode && errors.otpCode ? <div className={styles.formErrorMsg}>{errors.otpCode}</div> : null}
                      { showInvalidOTP && !errors.otpCode && <div className={styles.formErrorMsg}> { verificationMsg } </div> }
                    </Form.Row>
                  </Form>
                )}
              </Formik>
            </div>
          )}
        </div>
        }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          <X/> {" "} Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
